module.exports = __webpack_public_path__ + "media/images/search-by-fc5cbd1c26ce88c567808dc1d33e5e14.svg";